export enum ServiceabilityIndicator {
    Cancelled = "Cancelled",
    NonServiceable = "NonServiceable",
    Serviceable = "Serviceable",
    ServiceSerparate = "ServiceSerparate",
}
